import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceByCategories(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_FINANCE_BY_CATEGORIES,
		ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_CATEGORIES].GET_REPORTS_FINANCE_BY_CATEGORIES,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_CATEGORIES].GET_REPORTS_FINANCE_BY_CATEGORIES]: _getReportsFinanceByCategories,
}